import React from 'react'
import {
  enableForcedMinorUnlimitedDomain,
  enableFallbackUnlimitedDomain,
  listSchools
} from './adminHelpers'
import { noLog as log, shortenWithEllipsis } from '../../shared/Utils'
import styled from 'styled-components'
import { Block, BlockGroup, Button, H4, Spinner } from '@mote/ui'
import { AdminLayout } from '../../layouts/Admin/admin.layout'

class AdminSchools extends React.Component {
  constructor(props) {
    super(props)
    this.state = { mode: 'list', loading: true, institutions: [] }
  }

  componentDidMount() {
    this._refreshSchools()
  }

  render() {
    return (
      <AdminLayout>
        {this.state.mode === 'list' && (
          <Block gap={40} margin='100px 0 0 0'>
            <H4 alignment='center'>Schools Management</H4>

            {this.state.loading && (
              <Block margin='30px auto 0 auto'>
                {' '}
                <Spinner radius={90} />
              </Block>
            )}
            {this.state.error && (
              <p style={{ color: 'red' }}>{this.state.error}</p>
            )}
            {!this.state.loading && !this.state.error && this._renderSchools()}
          </Block>
        )}
      </AdminLayout>
    )
  }

  _renderSchools() {
    return (
      <div>
        {this.state.institutions.length === 0 && !this.state.loading && (
          <p>No schools found</p>
        )}
        {this.state.institutions.length > 0 && (
          <Table className='table truncate-school-name'>
            <thead className='thead-light'>
              <tr>
                <th className='text-uppercase' scope='col'>
                  Institution id
                </th>
                <th className='text-uppercase school-name' scope='col'>
                  Full school name
                </th>
                <th className='text-uppercase school-name' scope='col'>
                  Owner name{' '}
                </th>
                <th className='text-uppercase' scope='col'>
                  Owner email
                </th>
                <th className='text-uppercase school-name' scope='col'>
                  Domains
                </th>
                <th className='text-uppercase school-name' scope='col'>
                  Product
                </th>
                <th className='text-uppercase school-name' scope='col'>
                  Unused paid licenses?
                </th>
                <th className='text-uppercase school-name' scope='col'>
                  Seats used vs paid
                </th>

                <th className='text-uppercase school-name' scope='col'>
                  Subscription valid until
                </th>
              </tr>
            </thead>
            <tbody>
              {this.state.institutions.map(s => this._renderSchool(s))}
            </tbody>
          </Table>
        )}
      </div>
    )
  }

  _renderSchool(s) {
    var l = s.currentLicense
    log('rendering ...', s)
    log('with license...', l)
    return (
      <tr key={s.institutionId}>
        <td>
          <Button
            variant='link'
            tag='a'
            href={'/account?iid=' + s.institutionId}
            text={s.institutionId}
          />
        </td>
        <td>{shortenWithEllipsis(s.fullName, 40)}</td>
        <td>{s.accountOwnerName}</td>
        <td>{shortenWithEllipsis(s.accountOwnerEmail, 50)}</td>
        <td>{this._renderDomains(s)}</td>
        <td>{l.highestProductEnum}</td>
        <td>{l.canAddHighestProductEnumUsers ? 'Y' : 'N'}</td>
        <td>
          {l.totalPaidSeats - l.unusedPaidSeats}/{l.totalPaidSeats}{' '}
        </td>
        <td>{s.subscriptionValidUntil}</td>
      </tr>
    )
  }

  _renderDomains(s) {
    const unlimitedOn = s.enableFallbackUnlimitedDomain
    const unlimited =
      s.fallbackUnlimitedDomain || (unlimitedOn ? 'Not set' : 'Disabled')
    const unlimitedLoading = 'unlimited' + s.institutionId

    const unlimitedForcedMinorOn = s.enableForcedMinorUnlimitedDomain
    const unlimitedForcedMinor =
      s.forcedMinorUnlimitedDomain ||
      (unlimitedForcedMinorOn ? 'Not set' : 'Disabled')
    const unlimitedForcedMinorLoading = 'unlimitedForcedMinor' + s.institutionId

    return (
      <BlockGroup gap={10}>
        <Block gap={10}>
          Unlimited+force minor<b> - {unlimitedForcedMinor}</b>
          <Button
            variant='link'
            disabled={this.state[unlimitedForcedMinorLoading]}
            onClick={() => {
              const o = {}
              o[unlimitedForcedMinorLoading] = true
              this.setState(o)
              enableForcedMinorUnlimitedDomain(
                s.institutionId,
                !unlimitedForcedMinorOn,
                () => this._lightRefreshSchools(unlimitedForcedMinorLoading),
                () => {}
              )
            }}
            text={
              this.state[unlimitedForcedMinorLoading]
                ? 'Updating ...'
                : unlimitedForcedMinorOn
                ? 'Disable'
                : 'Enable'
            }
          />
        </Block>

        <Block gap={10}>
          Unlimited (unspecified age groups)<b> - {unlimited}</b>
          <Button
            variant='link'
            disabled={this.state[unlimitedLoading]}
            onClick={() => {
              const o = {}
              o[unlimitedLoading] = true
              this.setState(o)
              enableFallbackUnlimitedDomain(
                s.institutionId,
                !unlimitedOn,
                () => this._lightRefreshSchools(unlimitedLoading),
                () => {}
              )
            }}
            text={
              this.state[unlimitedLoading]
                ? 'Updating ...'
                : unlimitedOn
                ? 'Disable'
                : 'Enable'
            }
          />
        </Block>
      </BlockGroup>
    )
  }

  _lightRefreshSchools(loadingKey) {
    listSchools(
      data => {
        data[loadingKey] = false
        this.setState(data)
      },
      () => {
        var o = {}
        o[loadingKey] = false
        this.setState(o)
      }
    )
  }

  _refreshSchools() {
    if (this.state.mode === 'list') {
      listSchools(
        data => {
          this.setState(data)
          this.setState({ loading: false })
        },
        err => this.setState({ loading: false, error: err.toString() })
      )
    }
  }
}

export const AdminSchoolsScreen = AdminSchools

const Table = styled.table`
  border-collapse: collapse;
  width: 100%;
  margin-bottom: 20px;

  td {
    padding: 12px 14px;
    border-top: 1px solid #dee2e6;
    text-align: left;
    line-height: 16px;
    color: #646f7b;
  }

  thead th {
    border: 0;
    vertical-align: bottom;
  }

  tbody tr {
    &:hover {
      background: rgba(213, 212, 218, 0.25);
    }
  }

  th {
    text-align: left;
    padding: 22px 14px;
    font-weight: 400;
    border-top: 1px solid #dee2e6;
    background-color: #f9f9fb;
  }
`
